import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import {  Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { RecaptchaService } from 'src/app/core/services/recaptcha.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-change-booking',
  templateUrl: './change-booking.component.html',
  styleUrls: ['./change-booking.component.scss']
})
export class ChangeBookingComponent implements OnInit {
  public code: string = '';
  public myVar: boolean = false;
  public plant: string = '';
  public hour: string = '';
  public code2: string = '';
  public address: string = '';
  public date: string = '';
  public btnChange = 1;
  public myAlert: boolean = false;
  public myRecaptcha: boolean = false;
  public myProcesoRecaptcha: boolean = false

  constructor(
    private bookingService: BookingService,
    private route: Router,
    private authService: AuthService,
    private _recaptchaService: RecaptchaService,  
    private recaptchaV3Service: ReCaptchaV3Service
  ) { 

  }

  ngOnInit() {
    this.bookingService.resetVariables();
    this.authService.getChannel();
    this.authService.getTokenInit();
  }

  /*  */
  searchBooking() {
    if (this.code !== '') {
      gtag('event', 'Reagenda_Busqueda', {'event_category': 'Reagenda_Busqueda', 'event_label': 'Reagenda_Busqueda', 'value': 'Reagenda_Busqueda'});
      this.bookingService.verifyBooking(this.quitarFormato(this.code)).subscribe(
        response => {
          
          if (response.status === true) {
            this.bookingService.setDataChangeBooking(
              response.message.contact_name,
              response.message.email,
              response.message.phone_number,
              response.message.selected_date,
              response.message.selected_hour,
              response.message.vehicle_patent,
              response.message.vehicle_type
            );
            this.plant = response.message.plant;
            this.hour = moment(response.message.selected_hour, ['H:mm']).format('h:mm A');
            this.code2 = response.message.vehicle_patent;
            this.date = this.convertStringToFomart(response.message.selected_date);
            this.address = response.message.plant_address;
            this.myVar = true;
            this.btnChange = 0;
            this.myAlert = false;
          } else if (response.status === 'AMACL-786') {
            this.btnChange = 1;
            this.myVar = false;
            this.myAlert = true;
          }
        }
      );
    }
  }

  getInfoRecaptcha() {
    if (this.code !== '') {
      this.recaptchaV3Service.execute('importantAction')
        .subscribe((token) => {
          console.log(`Token [${token}] generated`)
            const auxiliar = this._recaptchaService.getTokenClientModule(token)
            auxiliar.subscribe( {
              complete: () => {

              },
              error: () => {
                this.myProcesoRecaptcha = true;
              },
              next: (resultado: Boolean) => {
                if (resultado === true) {
                  this.searchBooking();
                  this.myRecaptcha = false;
                } else {
                  this.myRecaptcha = true;
                }
              }
            });
        }
      );
    }
  }

  atras(){
    gtag('event', 'Atras3', {'event_category': 'Atras3', 'event_label': 'Atras3', 'value': 'Atras3'});
    this.route.navigate(['/booking/search-type']);
  }

  goDateChange() {
    if (this.myVar === true) {
      gtag('event', 'Reagenda2', {'event_category': 'Reagenda2', 'event_label': 'Reagenda2', 'value': 'Reagenda2'});
      this.route.navigateByUrl('/booking/date-change-booking');
    }
  }

  convertSecondsToHour(seconds, format = 'HH:mm') {
    return moment().startOf('day')
      .seconds(seconds)
      .format(format);
  }

  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  quitarFormato(patente) {
    return patente.replace(/\W+/g, '').toUpperCase();
  }
}
